import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { applicationStateSelectors } from "store/slices/applicationState/selectors";
import { useAppSelector } from "store/store.hooks";

/**
 * This component is parent for wrap all survey routes, and is a guard for check if feature is enabled on client project
 * If it is, the user will be redirected to home, otherwise to the survey page
 */
const SurveyRootRoute: React.FC = () => {
  const roomSelectorConfiguration = useAppSelector(
    applicationStateSelectors.roomSelectorConfiguration,
  );
  const isEnabled = roomSelectorConfiguration?.featureFlags.surveyModule;

  if (!isEnabled) {
    return <Navigate to='/' replace />;
  }

  return <Outlet />;
};

export default SurveyRootRoute;
